import * as React from "react"

const NotificationSvg = (props) => (
  <svg
    width={25}
    height={25}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M14.7 21.395a2 2 0 0 1-3.46 0m7.73-13a6 6 0 1 0-12 0c0 7-3 9-3 9h18s-3-2-3-9Z"
      stroke="#A57EA0"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default NotificationSvg
